export default __webpack_public_path__ + "static/media/sponsor_23.5d62c032.png";